const Trends = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000">
      <path d="m147-237-51-51 288-288 157 156 269-302 54 48-320 360-160-160-237 237Z" />
    </svg>
  );
};

export default Trends;
